const Blockly = require('blockly');
const dataAccessMethods = require('../../../../dataAccessMethods');
const mdcConfig = require('@sstdev/lib_metadata-config');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const convertToBoolean = require('../../../../helpers/convertToBoolean');
const { config } = mdcConfig;

const TOOLTIP =
    'Displays aggregated data from a namespace/relation (e.g. count of item/items).  Respects current filters.';

/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    let workspace = blocklyBlock.workspace;
    let blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);

    line1OfInputs
        .appendField('  Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('  Relation:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation');

    // Load possible actions and default action
    const actionsDropdown = new Blockly.FieldDropdown(config.dataAggregationOps);
    actionsDropdown.setValue('count');

    blocklyBlock
        .appendDummyInput('aggregateOperationInput')
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Center Label Above (instead of to the left):')
        .appendField(new Blockly.FieldCheckbox('false'), 'centerLabelAbove')
        .appendField('  Aggregate Operation:')
        .appendField(actionsDropdown, 'aggregateOperation');

    const addPropertyToAggregateIfNecessary = event => {
        if (event.blockId === blockId) {
            if ([Blockly.Events.BLOCK_CREATE, Blockly.Events.BLOCK_CHANGE].includes(event.type)) {
                const input = workspace.getBlockById(event.blockId).getInput('aggregateOperationInput');
                const propertyNameVisible = input?.fieldRow.some(field => field.name === 'propertyName');
                if (event.name === 'aggregateOperation') {
                    if (event.newValue !== 'count' && !propertyNameVisible) {
                        input
                            .appendField('  Property Name (for Sum, Average, Min, Max):', 'propertyNameLabel')
                            .appendField(new Blockly.FieldTextInput(), 'propertyName');
                    } else if (event.newValue === 'count' && propertyNameVisible) {
                        input?.removeField('propertyName');
                        input?.removeField('propertyNameLabel');
                    }
                }
            } else if (Blockly.Events.BLOCK_DELETE === event.type) {
                workspace.removeChangeListener(addPropertyToAggregateIfNecessary);
            }
        }
    };
    workspace.addChangeListener(addPropertyToAggregateIfNecessary);
}
/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties([
        'namespace',
        'relation',
        'aggregateOperation',
        'propertyName',
        { key: 'centerLabelAbove', handler: convertToBoolean }
    ]);
    return code;
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
